import type { Socket } from 'socket.io-client';
import { io } from 'socket.io-client';
import type { SocketNamespace } from '@trinity/chat';
import { resolveSocketOptions, isDebugEnabled } from './utils';

export function getSocket(data: GetSocketOptions): Socket {
  const url = `${data.baseUrl}/${data.namespace}`;
  const isDebug = isDebugEnabled();

  if (isDebug) {
    console.log('[WS Connect] Creating socket connection:', {
      url,
      namespace: data.namespace,
      baseUrl: data.baseUrl,
      socketPath: data.socketPath,
      hasSessionId: !!data.sessionId,
    });
  }

  const socket = io(url, resolveSocketOptions({
    socketPath: data.socketPath,
    sessionId: data.sessionId,
  }));

  // Add error handler for connection issues
  socket.on('connect_error', (error) => {
    console.error('[WS Connect Error]', {
      namespace: data.namespace,
      url,
      error: error.message,
      description: error['description'],
      context: error['context'],
      type: error['type'],
    });
  });

  if (isDebug) {
    socket.on('connect', () => {
      console.log('[WS Connect] Successfully connected:', {
        namespace: data.namespace,
        socketId: socket.id,
        transport: socket.io.engine.transport.name,
      });
    });

    socket.on('disconnect', (reason) => {
      console.log('[WS Disconnect]', {
        namespace: data.namespace,
        reason,
        socketId: socket.id,
      });
    });
  }

  return socket;
}

type GetSocketOptions = {
  baseUrl: string;
  socketPath: string;
  namespace: SocketNamespace;
  sessionId?: string;
};
